/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthClient } from './OAuthClient';
import {
    OAuthClientFromJSON,
    OAuthClientFromJSONTyped,
    OAuthClientToJSON,
    OAuthClientToJSONTyped,
} from './OAuthClient';

/**
 * 
 * @export
 * @interface RotateOauthClientSecretResponse
 */
export interface RotateOauthClientSecretResponse {
    /**
     * 
     * @type {OAuthClient}
     * @memberof RotateOauthClientSecretResponse
     */
    data: OAuthClient;
}

/**
 * Check if a given object implements the RotateOauthClientSecretResponse interface.
 */
export function instanceOfRotateOauthClientSecretResponse(value: object): value is RotateOauthClientSecretResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function RotateOauthClientSecretResponseFromJSON(json: any): RotateOauthClientSecretResponse {
    return RotateOauthClientSecretResponseFromJSONTyped(json, false);
}

export function RotateOauthClientSecretResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RotateOauthClientSecretResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': OAuthClientFromJSON(json['data']),
    };
}

  export function RotateOauthClientSecretResponseToJSON(json: any): RotateOauthClientSecretResponse {
      return RotateOauthClientSecretResponseToJSONTyped(json, false);
  }

  export function RotateOauthClientSecretResponseToJSONTyped(value?: RotateOauthClientSecretResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OAuthClientToJSON(value['data']),
    };
}

